import React from 'react';
import Reactour from "reactour";
import { withRouter } from "react-router-dom";
import jwt_decode from "jwt-decode";

const Tour = withRouter(
    ({ isOpen, closeTour, openTour, location: { pathname }, history }) => {
      const steps = [
        {
          selector: '[data-tut="reactour__user"]',
          content: () => (
            <div className='tour-step'>
              This is your Username.
            </div>),
        },
        {
            selector: '[data-tut="reactour__notify"]',
            content: () => (
              <div className='tour-step'>
                On click, It will show notifications and announcements.          
              </div>),
        },
        {
          selector: '[data-tut="reactour__help"]',
          content: () => (
            <div className='tour-step'>
              This is for reporting any issue and demo of application.          
            </div>),
      },
      {
        selector: '[data-tut="reactour__article"]',
        content: () => (
          <div className='tour-step'>
            Welcome to Wiki Space!
            <li>Here you can search for definitions of analysis and already published analysis related articles</li>
            <li>
              Click on search and type a keyword to search for related articles. Eg: Complex Type, Salmonella etc
            </li>
            <li>
            Click on publish, to create your own article and publish to your user group
            </li>
          </div>),
      },
      {
        selector: '[data-tut="reactour__addsample"]',
        content: () => (
          <div className='tour-step'>
            This is to add a sample in the application
          </div>),
      },
      {
        selector: '[data-tut="reactour__search"]',
        content: () => (
          <div className='tour-step'>
            This is to search for a Sample by Sample ID or Barcode or Location.
          </div>),
      },
      {
        selector: '[data-tut="reactour__dashboard"]',
        content: () => (
          <div className='tour-step'>
            On click, It will navigates to Dashboard.           
          </div>),
      },
      {
        selector: '[data-tut="reactour__ham"]',
        content: () => (
          <div className='tour-step'>
            On click, It will open menu.           
          </div>),
      },
        {
          selector: '[data-tut="reactour__navbar"]',
          content: () => (
            <div className='tour-step'>
              This is the Navigation. Click on it to navigate to other pages.
            </div>),
        },
        ...(["/samples/", "/samples", "/samples/floormap/", "/samples/floormap"].includes(pathname)
        ?[
          {
            selector: '[data-tut="reactour__floorPlan"]',
            content: () => (
              <div className='tour-step'>
                Welcome to Samples Page, Floor View.
              </div>),
             
          },
          {
            selector: '[data-tut="reactour__options"]',
            content: ({goto}) => (
            <div>
              <li> Select Building and Floor to locate samples on the floor, for which result has not arrived.</li>
              <li> Select Date to filter by Date.</li>
              <li>Select WGS or Other to filter by Type of Analysis. Default analysis is WGS. </li>
              Then, Click on <strong>APPLY</strong> to view Samples on Floorplan or <strong>CLEAR</strong> to select again
            </div>),
            },
            {
              selector: '[data-tut="reactour__floor"]',
              content: () => (
                <div className='tour-step'>
                  This is the selected floor. Click on any Room,
                  <li> To add or view the samples in that room</li>
                </div>),
            },
            {
              selector:'[data-tut="reactour__nav"]',
              content: () => (
                <div className='tour-step'>
                  Click on List of Samples, to move to list view of samples page.
                </div>),
            },
            {
              selector:'[data-tut="reactour__nav"]',
              content: () => (
                <div className='tour-step'>
                  Takes us to floor page.
                </div>),
              action: () => {history.push("/samples/addsamples/")}
            }
        ]
          :["/samples/addsamples/", "/samples/addsamples"].includes(pathname)
            ?[
              {
                selector: '[data-tut="reactour__sample"]',
                content: ({goTo}) => (
                <div className='tour-step'>
                  Welcome to Samples Page.
                </div>),
                action: () => window.scrollTo(0, 0)
               },
              {
                selector: '[data-tut="reactour__tableDelete"]',
                content:  () => (
                  <div className='tour-step'>
                    Click on it to delete the samples that are selected
                  </div>),
              },
              {
                selector: '[data-tut="reactour__tableEdit"]',
                content:  () => (
                  <div className='tour-step'>
                    Click on it to edit a saved sample data, after selecting a row in the table. 
                    <br /> <strong>Note: </strong>Edit can be used to change the type of analysis after the result is available.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__editModal"]',
                content:  () => (
                  <div className='tour-step'>
                    Update the sample data by filling all the *mandatory fields.
                  <br /> Then, Click on <strong>SAVE</strong> to update the sample or <strong>CANCEL</strong> to close the edit.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__deleteModal"]',
                content:  () => (
                  <div className='tour-step'>
                    Delete Confirmation.
                  <br /> Then, Click on <strong>DELETE</strong> to delete the sample or <strong>CANCEL</strong> to close the delete.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__downloads"]',
                content: () => (
                  <div className='tour-step'>
                    Downloads all samples to an Excel File.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__uploads"]',
                content: () => (
                  <div className='tour-step'>
                    Uploads samples to the Applications. 
                    <br /> <strong>Note: </strong>On click you will get option to Download Template and Upload xlsx File.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__table"]',
                content: () => (
                  <div className='tour-step'>
                    Samples table containing recently updated and result waiting samples.
                  </div>),
              },
              {
                selector:'[data-tut="reactour__tableDelete"]',
                content: () => (
                  <div className='tour-step'>
                    Click on Floor View, to move floor view of samples page.
                  </div>),
                action: () => {history.push("/results/")}
              }
            ]
            :["/results/", "/results", "/results/viewresults", "/results/viewresults/"].includes(pathname)
              ?[
                {
                  selector: '[data-tut="reactour__results"]',
                  content: () => (
                    <div className='tour-step'>
                      Welcome to View Results Page.
                    </div>),
                },
                {
                  selector: '[data-tut="reactour__apply"]',
                  content: () => (
                    <div className='tour-step'>
                      It has list of options to view results on the Floor Plan.
                      <li>Select Building, Floor and Date to view results.</li>
                      <li>Select Type of Sample, or Organism to filter by them.</li>
                      <li>Select WGS or Other to filter by Type of Analysis. Default analysis is WGS. </li>
                      <br /> Then, Click on <strong>Apply</strong> to get Floor Plan or <strong>CLEAR</strong> to select again.
                    </div>),
                },
                {
                  selector: '[data-tut="reactour__floor"]',
                  content: () => (
                    <div className='tour-step'>
                      This is the selected floor. 
                      <li> Click on any Room, to view results in that room.</li>
                      <li> Using + and -, we can Zoom In and Zoom Out the Floor Plan.</li>
                      <li> {"Using < and > at the top Floor Plan, we can change the Date."}</li>
                    </div>),
                },
                {
                  selector: '[data-tut="reactour__grid"]',
                  content: () => (
                    <div className='tour-step'>
                      On click this displays results in a Table.
                    </div>),
                },
                {
                  selector: '[data-tut="reactour__grid"]',
                  content:  () => (
                    <div className='tour-step'>
                      Takes us to results grid view.
                    </div>),
                  action: () => {history.push("/results/viewresults/grid-view/")}
                }
              ]
            :["/results/viewresults/grid-view", "/results/viewresults/grid-view/"].includes(pathname)
            ?[
              {
                selector: '[data-tut="reactour__results"]',
                content: () => (
                  <div className='tour-step'>
                    Welcome to Results Grid View.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__options"]',
                content: () => (
                <div className='tour-step'>
                  It has list of options to filter results in the table.
                  <br /> Select the options and Click on <strong>Apply</strong> to get filtered results or <strong>CLEAR</strong> to select again.
                </div>
                ),
              },
              {
                selector: '[data-tut="reactour__table"]',
                content: () => (
                  <div className='tour-step'>
                    Results table containing all the available results.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__downloads"]',
                content: () => (
                  <div className='tour-step'>
                    Downloads all the available results to an Excel File.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__uploads"]',
                content: () => (
                  <div className='tour-step'>
                    Uploads results to the Applications. 
                    <br /> <strong>Note: </strong>On click you will get option to Download Template and Upload xlsx/csv File.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__floor"]',
                content: () => (
                  <div className='tour-step'>
                    On click this displays the floor view of results.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__floor"]',
                content: () => (
                  <div className='tour-step'>
                    Takes us to track results.
                  </div>),
                action: () => {history.push("/results/trackresults/")}
              },
            ]
            :["/results/trackresults", "/results/trackresults/"].includes(pathname)
            ?[
              {
                selector: '[data-tut="reactour__results"]',
                content: () => (
                  <div className='tour-step'>
                    Welcome to Track Results Page.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__apply"]',
                content: () => (
                  <div className='tour-step'>
                    It has list of options to Track results on the Floor Plan.
                    <li>Select Building, Floor, From Date and To Date.</li>
                    <li>Select Organism and at most five Complex Type to filter results. And then track results.</li>
                    <li>Select Batch Number and Type of Sample to filter results by them.</li>
                    <br /> Then, Click on <strong>Apply</strong> to get a Floor Plan or <strong>CLEAR</strong> to select again.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__resultView"]',
                content: () => (
                  <div className='tour-step'>
                    This is results display area.
                    <br /> Click on, Timeline View or Floor View at the top right to switch between views.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__results"]',
                content:  () => (
                  <div className='tour-step'>
                    Takes us to SNP Results page.
                  </div>),
                action: () => {history.push("/results/snpresults/")}
              }
            ]
            :["/results/snpresults", "/results/snpresults/"].includes(pathname)
            ?[
              {
                selector: '[data-tut="reactour__results"]',
                content: () => (
                  <div className='tour-step'>
                    Welcome to SNP Results Page.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__apply"]',
                content: () => (
                  <div className='tour-step'>
                    It has list of options get SNP results as matrix.
                    <br /> Select Building, Floor, Organism and Batch Number.
                    <br /> Then, Click on <strong>Apply</strong> to get SNP Matrix  or <strong>CLEAR</strong> to select again.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__uploads"]',
                content: () => (
                  <div className='tour-step'>
                    Uploads SNP results to the Applications. 
                    <br /> <strong>Note: </strong>On click you will get option to Download Template and Upload xlsx/csv File.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__resultView"]',
                content: () => (
                  <div className='tour-step'>
                    This is results display area.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__apply"]',
                content:  () => (
                  <div className='tour-step'>
                    Takes us to Manage page.
                  </div>),
                  action: () => {localStorage.getItem("guest")?history.push("/dashboard/"):history.push("/manage/")}            
                }
            ]
            :["/results/biomeresults", "/results/biomeresults/"].includes(pathname)
            ?[
              {
                selector: '[data-tut="reactour__results"]',
                content: () => (
                  <div className='tour-step'>
                    Welcome to Microbiome Results Page.
                  </div>),
              },

              {
                selector: '[data-tut="reactour__apply"]',
                content: () => (
                  <div className='tour-step'>
                    It has a list of options to get the Microbiome results.
                    <br /> Select Building and Floor, along with the timeframe.
                    <br /> Then, Click on <strong>Apply</strong> to get the floorplan along with the Microbiome Results or <strong>CLEAR</strong> to select again.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__resultView"]',
                content: () => (
                  <div className='tour-step'>
                    This is results display area.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__apply"]',
                content:  () => (
                  <div className='tour-step'>
                    Takes us to Manage page.
                  </div>),
                  action: () => {localStorage.getItem("guest")?history.push("/dashboard/"):history.push("/results/biomeresults/grid-view")}            
                }
            ]
            :["/results/biomeresults/grid-view"].includes(pathname)
            ?[
              {
                selector: '[data-tut="reactour__results"]',
                content: () => (
                  <div className='tour-step'>
                    Welcome to Microbiome List View.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__apply"]',
                content: () => (
                  <div className='tour-step'>
                    It has a list of options to get the Microbiome results.
                    <br /> To filter values, select Building and Floor, along with the location and organism.
                    <br /> Then, Click on <strong>Apply</strong> to get the list of all Microbiome Results or <strong>CLEAR</strong> to select again.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__downloads"]',
                content: () => (
                  <div className='tour-step'>
                    Click on download to get the list of all results in the form of an Excel.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__uploads"]',
                content: () => (
                  <div className='tour-step'>
                    If you wish to upload Microbiome result, click on Upload results
                  </div>),
              },
              {
                selector: '[data-tut="reactour__apply"]',
                content:  () => (
                  <div className='tour-step'>
                    Takes us to Manage page.
                  </div>),
                  action: () => {localStorage.getItem("guest")?history.push("/dashboard/"):history.push("/results/speciesdensity")}            
                }
            ]
            :["/results/speciesdensity", "/results/speciesdensity/"].includes(pathname)
            ?[
              {
                selector: '[data-tut="reactour__results"]',
                content: () => (
                  <div className='tour-step'>
                    Welcome to Species Density Page.
                  </div>),
              },

              {
                selector: '[data-tut="reactour__apply"]',
                content: () => (
                  <div className='tour-step'>
                    It has a list of options to get the Average Species Percentage present in each location on the floor.
                    <br /> Once the Building and Floor has been selected, the species pertaining to the floor will be displayed. 
                    <br /> Select the species, along with the desired timeframe.
                    <br /> Then, Click on <strong>Apply</strong> to get the floorplan along with the heatmap for the selected species or <strong>CLEAR</strong> to select again.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__resultView"]',
                content: () => (
                  <div className='tour-step'>
                    This is Species Results display area.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__apply"]',
                content:  () => (
                  <div className='tour-step'>
                    Takes us to Manage page.
                  </div>),
                  action: () => {localStorage.getItem("guest")?history.push("/dashboard/"):history.push("/manage/")}            
                }
            ]
            :["/manage/notifications", "/manage/notifications/"].includes(pathname)
            ?[
              {
                selector: '[data-tut="reactour__manage"]',
                content: () => (
                  <div className='tour-step'>
                    Welcome to Manage Notifications Page.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__apply"]',
                content: () => (
                  <div className='tour-step'>
                    Fill all *mandatory fields to add a notification. 
                    <br /> Then, Click on <strong>ADD</strong> to add notification or <strong>CLEAR</strong> to fill again.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__table"]',
                content: () => (
                  <div className='tour-step'>
                    Notifications table contianing the all the notifications.
                    <br /><strong>Note:</strong> Order by the occurence of the notifications.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__delete"]',
                content: () => (
                  <div className='tour-step'>
                    Click on it to mark the notification as done.                 
                  </div>),
              },
              {
                selector: '[data-tut="reactour__edit"]',
                content: () => (
                  <div className='tour-step'>
                    Click on it to update a notification.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__editAll"]',
                content: () => (
                  <div className='tour-step'>
                    This is recurrent notification.
                    <br />Click on it to update the recurrent notification.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__one"]',
                content: () => (
                  <div className='tour-step'>
                    This is one-time notification.
                    <br />Click on it to update the notification.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__apply"]',
                content:  () => (
                  <div className='tour-step'>
                    Takes us to Manage Buildings page.
                  </div>),
                action: () => {history.push("/dashboard")},
              },
            ]
            :["/manage/","/manage/","/manage/buildings/addbuildings", "/manage/buildings/addbuildings/"].includes(pathname)
            ?[
              {
                selector: '[data-tut="reactour__manage"]',
                content: () => (
                  <div className='tour-step'>
                    Welcome to Manage Building Page.
                    <li>Click on Buildings and Floors, to view all the buildings.</li>
                    <li>Click on Rooms, to view all the Rooms.</li>
                  </div>),
              },
              {
                selector: '[data-tut="reactour__apply"]',
                content: () => (
                  <div className='tour-step'>
                    <li> Select + Floor to get a Popup to add a new floor.</li>
                   <li>Select + Building to get a Popup to add a new building.</li>        
                   <li>Then, Click on <strong>SAVE</strong> to add building/floor or <strong>CLEAR</strong> to fill again.</li>
                  </div>),
              },
              {
                selector: '[data-tut="reactour__table"]',
                content: () => (
                  <div className='tour-step'>
                    This table contains all the Buildings along with their corresponding floors.
                  </div>),
              },
            ]
            :["/manage/buildings/addFloors", "/manage/buildings/addFloors/"].includes(pathname)
            ?[
              {
                selector: '[data-tut="reactour__manage"]',
                content: () => (
                  <div className='tour-step'>
                    Welcome to Manage Floor Page.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__tableFloor"]',
                content: () => (
                  <div className='tour-step'>
                    Floors table contianing the all the Floors.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__dropdown"]',
                content: () => (
                  <div className='tour-step'>
                    <li>Select Add a Building from the dropdown to navigate to Manage Building page.</li>
                    <li>Select Add a Room from the dropdown to navigate to Manage Room page.</li>  
                    <li>Fill all fields to add a floor. </li>
                    <li> Then, Click on <strong>ADD</strong> to add floor or <strong>CLEAR</strong> to fill again.</li>        
                  </div>),
              },
              {
                selector: '[data-tut="reactour__dropdown"]',
                content:  () => (
                  <div className='tour-step'>
                    Takes us to Manage Rooms page.
                  </div>),
                action: () => {history.push("/manage/buildings/addRooms/")},
              },
            ]
            :["/manage/buildings/addRooms","/manage/buildings/addRooms/"].includes(pathname)
            ?[
              {
                selector: '[data-tut="reactour__manage"]',
                content: () => (
                  <div className='tour-step'>
                    Welcome to Manage Rooms Page.
                  </div>),
              },
                  {
                        selector: '[data-tut="reactour__tableRoom"]',
                        content: () => (
                          <div className='tour-step'>
                            Rooms table contianing all the Rooms.
                          </div>),
                   },
                   {
                    selector: '[data-tut="reactour__dropdown"]',
                    content: () => (
                      <div className='tour-step'>
                        <li>Select Add a Building from the dropdown to navigate to Manage Building page.</li>
                        <li>Select Add a Floor from the dropdown to navigate to Manage Floor page.</li>          
                        <li>Fill all fields to add a floor. </li>
                        <li> Then, Click on <strong>ADD</strong> to add floor or <strong>CLEAR</strong> to fill again.</li>        
                  
                      </div>),
                  },
                  {
                    selector:'[data-tut="reactour__nav"]',
                    content: () => (
                      <div className='tour-step'>
                        Click on Map Locations, to move to Add Locations page.
                      </div>),
                  },
                  {
                        selector: '[data-tut="reactour__nav"]',
                        content:  () => (
                          <div className='tour-step'>
                            Takes us to Add location page.
                          </div>),
                        action: () => {history.push("/manage/addLocations/")},
                  },
            ]
            :["/manage/addLocations", "/manage/addLocations/"].includes(pathname)
              ?[
                {
                  selector: '[data-tut="reactour__addLocations"]',
                  content:  () => (
                    <div className='tour-step'>
                      Welcome to Add Locations Page.
                    </div>),
                   
                },
                {
                  selector: '[data-tut="reactour__apply"]',
                  content: () => (
                    <div className='tour-step'>
                      It has options Building and Floor, to get a Floor Plan.
                      <br /> Then, Click on <strong>Apply</strong> to get a Floor Plan or <strong>CLEAR</strong> to select again.
                    </div>),
                },
                {
                  selector: '[data-tut="reactour__add"]',
                  content: () => (
                    <div className='tour-step'>
                      Using these buttons we can add Building, Floor and Room. 
                    </div>),
                },
                {
                  selector: '[data-tut="reactour__floor"]',
                  content: () => (
                    <div className='tour-step'>
                      This is the selected floor. 
                    </div>),
                },
                {
                  selector: '[data-tut="reactour__addLocation"]',
                  content: ({goto}) => (
                    <div>
                      Fill all *mandatory and enabled fields.
                      <ul>
                        <li>Type Loctions ID.</li>
                        <li>If room is reactangle, 
                          <ul><li>click on the oppsite corners of the room.</li></ul>
                        </li>
                        <li>Otherwise, 
                          <ul>
                            <li>Click on the corners of the room in a sequence, to get the corrdinates of the room.</li>
                            <li>If not a reactanglar room, select reactanglar coords from the corrdinates drop down.</li>
                            <li>And, click on the oppsite corners of the large possible reactangle in the room.</li>
                          </ul>
                        </li>
                        <li>Select room from the Rooms dropdown.</li>
                      </ul>
                    </div>),
                },
                {
                  selector: '[data-tut="reactour__applyLocations"]',
                  content: () => (
                    <div className='tour-step'>
                      <li>To add new location, click on <strong>Add New</strong></li>
                      <li>To save all added locations, click on <strong>Save All</strong></li>
                      <li>To clear all added locations, click on <strong>clear</strong></li> 
                    </div>),
                },
                {
                  selector: '[data-tut="reactour__locations"]',
                  content: () => (
                    <div className='tour-step'>
                      Locations table containing rooms of the floor.
                    </div>),
                },
                {
                  selector:'[data-tut="reactour__nav"]',
                  content: () => (
                    <div className='tour-step'>
                      Click on View Locations, to move to Locations page.
                    </div>),
                },
                {
                  selector: '[data-tut="reactour__nav"]',
                  content: () => (
                    <div className='tour-step'>
                      Take us to vieW Locations Page.
                    </div>),
                  action: () => {history.push("/manage/locations/")}
                },
              ]
            :[ "/manage/locations", "/manage/locations/"].includes(pathname)
            ?[
              {
                selector: '[data-tut="reactour__manage"]',
                content: () => (
                  <div className='tour-step'>
                    Welcome to Manage Locations Page.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__apply"]',
                content: () => (
                  <div className='tour-step'>
                    Select the list of options to search for a Location.
                    <br /> Then, Click on <strong>Apply</strong> to get Loctions or <strong>CLEAR</strong> to select again.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__table"]',
                content: () => (
                  <div className='tour-step'>
                    Locations table contianing the all available locations
                  </div>),
              },
              {
                selector: '[data-tut="reactour__delete"]',
                content: () => (
                  <div className='tour-step'>
                    Click on it to delete the location.                 
                  </div>),
              },
              {
                selector: '[data-tut="reactour__print"]',
                content: () => (
                  <div className='tour-step'>
                    Click on it to print the Barcode for the location.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__downloads"]',
                content: () => (
                  <div className='tour-step'>
                    Downloads all locations to an Excel File.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__printAll"]',
                content: () => (
                  <div className='tour-step'>
                    Prints Barcodes of all the Loctions in the table.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__add"]',
                content: () => (
                  <div className='tour-step'>
                    To add a new unit in a room.
                  </div>),
              },
              {
                selector:'[data-tut="reactour__nav"]',
                content: () => (
                  <div className='tour-step'>
                    Click on Manage Notifications, to move to Manage Notifications page.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__nav"]',
                content:  () => (
                  <div className='tour-step'>
                    Takes us to Manage Notifications page.
                  </div>),
                action: () => {history.push("/register")},
              },
            ]
            :[ "/register", "/register/"].includes(pathname) && localStorage.getItem('auth_token') && jwt_decode(localStorage.getItem('auth_token')) && ((jwt_decode(localStorage.getItem('auth_token')).user_group && jwt_decode(localStorage.getItem('auth_token')).user_group.includes('admin')))
            ?[
              {
                selector: '[data-tut="reactour__register"]',
                content: () => (
                  <div className='tour-step'>
                    Welcome to the User management page.<br/> 
                    Here, you will be able to <strong>add new users</strong> to your labs.
                  </div>),
              },
              {
                selector: '[data-tut="reactour__registeruser"]',
                content: () => (
                  <div className='tour-step'>
                    Add new users by entering their details below.<br/> 
                    The password would be sent to the entered email automatically on click of the <strong>Add User</strong> button!
                  </div>),
              },
            ]
          : ["/dashboard", "/dashboard/"].includes(pathname)
          ? [
            {
              selector: '[data-tut="reactour__dashboardPage"]',
              content: () => (
                <div className='tour-step'>
                  Welcome to Dashoard Page.
                </div>),
            },
              {
                selector: '[data-tut="reactour__samples"]',
                content:  () => (
                  <div className='tour-step'>
                    Total samples saved and result waiting samples.
                  </div>),                 
              },
              {
                selector: '[data-tut="reactour__ctcard"]',
                content:  () => (
                  <div className='tour-step'>
                    Most common CT type based on selected period.
                  </div>),                 
              },
              {
                selector: '[data-tut="reactour__stcard"]',
                content:  () => (
                  <div className='tour-step'>
                    Most common ST type based on selected period.
                  </div>),                 
              },
              {
                selector: '[data-tut="reactour__results"]',
                content:  () => (
                  <div className='tour-step'>
                    Total samples collected and samples waiting for results based on different type of analysis.
                  </div>),                 
              },
              {
                selector: '[data-tut="reactour__graph"]',
                content:  () => (
                  <div className='tour-step'>
                   <li>It shows the most common Complex type based on selected period when user selects complex type from the dropdown.</li>
                    <li>It shows the most common sequence type based on selected period when user selects sequence type from the dropdown.</li>
                  </div>),                 
              },
              {
                selector: '[data-tut="reactour__graphtwo"]',
                content:  () => (
                  <div className='tour-step'>
                    It shows Sample and Result distribution on different floors of different buildings based on the selected time period. 
                  </div>),                 
              },
              {
                selector: '[data-tut="reactour__graphthree"]',
                content:  () => (
                  <div className='tour-step'>
                    It shows the top 5 species which are obtained, based on the selected time period for the Microbiome Analysis. 
                  </div>),                 
              },
              {
                selector: '[data-tut="reactour__recent"]',
                content:  () => (
                  <div className='tour-step'>
                    Table containing the Recent activities.
                  </div>), 
                action: () => window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: "smooth" })
              },
              {
                selector: '[data-tut="reactour__navbar"]',
                content: "This is the Navigation. Click on it to navigate to other pages.",
                 
              },
            ]
            :[
              {
                selector: '[data-tut="reactour__dashboard"]',
                content: `On click redirects to view Dashboard.`,
                 
              },
            ])
          ];
      const onScreenSteps = steps.filter(({ selector }) => {
        return document.querySelector(selector)
        ? !!document.querySelector(selector).clientWidth
        : false
            }
      )

      return (
        <Reactour
          steps={onScreenSteps}
          isOpen={isOpen}
          startAt={onScreenSteps.length-1>8?8:onScreenSteps.length-1}
          onRequestClose={closeTour}
          update={pathname}
          disableFocusLock={true}
          maskClassName="tour-mask"
          accentColor="#364db2"
          rounded={5}
        />
      );
    }
  );
  
  export default Tour;